import React from "react";
import AuthTopNav from "../containers/TopNav/AuthTopNav";
import MobileNavbar from "../containers/MobileNavbar";
import Footer from "../containers/Footer";
import UserDetailsForm from "../containers/UserDetailsForm/UserDetailsForm";
import ProfileCompleteness from "../containers/ProfileCompleteness";
import DashboardNewCircle from "../components/DashboardNewCircle";

const MyAccount = () => {
    return (
        <div className="app-wrapper has-mobile-navbar">
            <AuthTopNav />
            <section className="gray-bg">
                <div className="main-container">
                    <div className="content-wrapper has-sidebar">

                        <UserDetailsForm />

                        <div className="sidebar-content">
                            <ProfileCompleteness />

                            <DashboardNewCircle />
                        </div>
                    </div>
                </div>
            </section>
            <MobileNavbar />
            <Footer />
        </div>
    );
}
export default MyAccount;
